import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    popup: null,
    menuIsOpen: false,
    isMobile: false,
    isMobileDevice: false,
    deviceHeight: 0, // Реальная высота устройства

    hideBurger: false, // opacity:0;pointerEvents:none;
    whiteHeader: true,
  },
  mutations: {
    openPopup(state, popup) {
      state.popup = popup;
    },
    closePopup(state) {
      state.popup = null;
      state.popupData = null;
    },
    openMenu(state){
      state.menuIsOpen = true;
    },
    closeMenu(state){
      state.menuIsOpen = false;
    },
    toggleMenu(state){
      state.menuIsOpen = !state.menuIsOpen;
    },

    checkMobile(state){
      state.isMobile = document.documentElement.offsetWidth < 768;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        state.isMobileDevice = true;
      }

      state.deviceHeight = document.documentElement.clientHeight;
    },
  },
  actions: {
  },
  modules: {
  },

})
